var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6102 5.94695C23.8702 3.20847 18.6001 3.80635 15.6736 7.49152C12.8333 11.0683 13.5415 16.2149 17.2816 18.9534C21.0223 21.6924 26.3781 20.9859 29.2185 17.4091C32.1449 13.7239 31.3509 8.68592 27.6102 5.94695ZM25.8888 8.11469C27.1361 9.02796 27.3717 10.7431 26.4249 11.9354C25.4781 13.1277 23.6932 13.3634 22.4459 12.4502C21.1995 11.5376 20.9634 9.82197 21.9101 8.62971C22.8569 7.43745 24.6424 7.20209 25.8888 8.11469Z",
    fill: "#b8bcb4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4299 4.95891C23.6896 2.22019 18.3452 2.91161 15.493 6.50323C12.6409 10.0949 13.3609 15.2267 17.1013 17.9654C20.8421 20.7044 26.1861 20.0127 29.0382 16.4211C31.8904 12.8294 31.1707 7.69789 27.4299 4.95891ZM25.7085 7.12666C26.9558 8.03993 27.1954 9.75013 26.2446 10.9474C25.2939 12.1446 23.5129 12.3754 22.2656 11.4621C21.0188 10.5492 20.7788 8.83868 21.7295 7.64143C22.6803 6.44419 24.4617 6.21372 25.7085 7.12666Z",
    fill: "#b8bcb4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3485 19.3613L14.5759 14.4023L12.8545 16.5701L19.6271 21.529L21.3485 19.3613Z",
    fill: "#b8bcb4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9832 17.3965L6.23668 27.1513L6.77278 30.9721L10.7517 30.4573L11.6125 29.3734L10.2157 26.6366L13.3339 27.2057L14.1946 26.1218L13.9266 24.2114L15.9161 23.954L18.4982 20.7024L13.9832 17.3965Z",
    fill: "#b8bcb4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3694 19.875L13.9266 24.2105L15.9161 23.9531L18.4982 20.7015L17.3694 19.875ZM13.9266 24.2105L11.7748 26.9202L13.3339 27.2047L14.1946 26.1208L13.9266 24.2105ZM10.9141 28.004L8.76225 30.7137L10.7517 30.4563L11.6125 29.3725L10.9141 28.004Z",
    fill: "#b8bcb4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.112 18.2227L6.50481 29.0614L6.77286 30.9717L10.2157 26.6362L16.2408 19.0491L15.112 18.2227Z",
    fill: "#b8bcb4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.dfce94dc0b7fb9d41734c98569cce374.svg";
export { ForwardRef as ReactComponent };